module.exports = "<mat-toolbar color=\"primary\"><span [routerLink]=\"['/']\">Calcutta</span><span class=\"spacer\"></span><span *ngIf=\"afAuth.authState | async as user\">\n</span><button mat-raised-button color=\"accent\" (click)=sharedService.logout()>Logout</button></mat-toolbar>\n<router-outlet class=\"app-content\"></router-outlet>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main